import { Injectable, inject, signal } from '@angular/core';
import { BI_CORE_CONFIG } from './config';

@Injectable({
  providedIn: 'root',
})
export class FrameDetectionService {
  private readonly config = inject(BI_CORE_CONFIG);
  inIframe = signal(this.isEmbedded());

  public isEmbedded(): boolean {
    try {
      return this.config.iframeEnabled || window.self !== window.top;
    } catch (e) {
      console.warn(e);
      // Puede llegar aquí tras bloquear el acceso a window.top (por ejemplo, en un iframe)
      return true;
    }
  }
}
